// DV: helpers for DV service notes in account 1 «Дядя Ваня Вьетнам».

export const DV_ACCOUNT_ID = 1;

// Emitted by the draft card in a note, handled by ReplyTopPanel.
export const DV_INSERT_DRAFT_EVENT = 'dvAssistantDraft:insert';

export function parseContentAttributes(value) {
  let attributes = value;
  try {
    while (typeof attributes === 'string') {
      attributes = JSON.parse(attributes);
    }
  } catch (error) {
    return {};
  }
  return attributes && typeof attributes === 'object' ? attributes : {};
}

// Assistant note info: { draft, model, intent } for any assistant_claude
// note; draft is '' when the agent decided not to write one.
export function assistantNoteFromAttributes(value) {
  const attributes = parseContentAttributes(value);
  const source = attributes.source_module || attributes.sourceModule || '';
  if (source !== 'assistant_claude') return null;

  return {
    draft: String(
      attributes.assistant_draft_text || attributes.assistantDraftText || ''
    ).trim(),
    model: String(attributes.assistant_model || attributes.assistantModel || ''),
    intent: String(
      attributes.assistant_intent || attributes.assistantIntent || ''
    ),
  };
}

// Short human reason from a no-draft note: the italic line under the header.
export function assistantNoDraftReason(content, intent = '') {
  if (intent === 'no_reply_needed') {
    return 'клиенту сейчас отвечать не нужно — нет нового вопроса.';
  }
  const head = String(content || '').split(/\n-{3,}\s*\n/u)[0] || '';
  const reason = head
    .split('\n')
    .filter(line => !/^\s*\*\*[^*]+\*\*\s*$/u.test(line))
    .join(' ')
    .replace(/[_*]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
  return reason || 'агент решил, что черновик здесь не нужен.';
}

// «Данные клиента» note: structured dossier written by the backend.
export function clientDossierFromAttributes(value) {
  const attributes = parseContentAttributes(value);
  const dossier = attributes.dv_client_dossier || attributes.dvClientDossier;
  return dossier && typeof dossier === 'object' ? dossier : null;
}

// Action Center trigger for the dossier: redundant once the result arrives.
export function isDossierTriggerNote(value) {
  const attributes = parseContentAttributes(value);
  const source = attributes.source_module || attributes.sourceModule;
  const command = String(
    attributes.action_center_command || attributes.actionCenterCommand || ''
  );
  return (
    source === 'chatwoot_action_center' &&
    /contact[-_]context/.test(command) &&
    !attributes.automation_action &&
    !attributes.automationAction &&
    !clientDossierFromAttributes(attributes)
  );
}

// Staff agent drafts (Руслан, Алексей… via the Agent API). New notes carry
// content_attributes (source_module "staff_agent" + dv_agent_draft); older ones
// are plain text "Claude draft for operator review …" and are parsed here.
const STAFF_AGENT_HEADER = 'Claude draft for operator review';
const STAFF_AGENT_FOOTER = 'Operator must review before sending';
const STAFF_AGENT_FINDINGS = '⚠️ Проверка на выходе:';

const parseStaffAgentText = content => {
  const text = String(content || '').replace(/\r\n/g, '\n');
  if (!text.startsWith(STAFF_AGENT_HEADER)) return null;

  const fields = {};
  const lines = text.split('\n');
  let index = 1;
  for (; index < lines.length; index += 1) {
    const line = lines[index];
    if (!line.trim()) break;
    const match = line.match(/^([A-Za-z ]+):\s*(.*)$/);
    if (match) fields[match[1].trim().toLowerCase()] = match[2].trim();
  }

  const rest = lines.slice(index).join('\n');
  const draftStart = rest.indexOf('Draft reply to client:');
  if (draftStart === -1) return null;
  let body = rest.slice(draftStart + 'Draft reply to client:'.length);
  const footerAt = body.indexOf(STAFF_AGENT_FOOTER);
  if (footerAt !== -1) body = body.slice(0, footerAt);

  let findings = [];
  const findingsAt = body.indexOf(STAFF_AGENT_FINDINGS);
  if (findingsAt !== -1) {
    findings = body
      .slice(findingsAt + STAFF_AGENT_FINDINGS.length)
      .split('\n')
      .map(line => line.trim())
      .filter(Boolean)
      .map(line => ({
        severity: line.startsWith('❗') ? 'hard' : 'soft',
        message: line.replace(/^[❗•]\s*/u, ''),
      }));
    body = body.slice(0, findingsAt);
  }

  return {
    draft: body.trim(),
    model: fields.model || '',
    operator: fields['generated by'] || '',
    summary: fields.summary || '',
    generatedAt: fields['generated at'] || '',
    source: fields.source || '',
    riskFlags: fields['risk flags']
      ? fields['risk flags'].split(',').map(flag => flag.trim()).filter(Boolean)
      : [],
    findings,
  };
};

export function staffAgentDraftFromNote(value, content) {
  const attributes = parseContentAttributes(value);
  const source = attributes.source_module || attributes.sourceModule || '';
  if (source === 'staff_agent') {
    const meta = attributes.dv_agent_draft || attributes.dvAgentDraft || {};
    const draft = String(
      attributes.assistant_draft_text || attributes.assistantDraftText || ''
    ).trim();
    if (draft) {
      return {
        draft,
        model: String(attributes.assistant_model || attributes.assistantModel || ''),
        operator: String(meta.operator || ''),
        summary: String(meta.summary || ''),
        generatedAt: String(meta.generated_at || meta.generatedAt || ''),
        source: String(meta.source || ''),
        riskFlags: Array.isArray(meta.risk_flags || meta.riskFlags)
          ? meta.risk_flags || meta.riskFlags
          : [],
        findings: Array.isArray(meta.findings) ? meta.findings : [],
      };
    }
  }
  return parseStaffAgentText(content);
}
